import { apiClient } from './client';

export type ShareCapability = 'agent.view' | 'agent.control' | 'agent.chat' | 'agent.terminal';
export interface ComputerShare {
  id: string;
  username: string;
  capabilities: string[];
  expiresAt: string | null;
}
export interface ComputerSharingInfo {
  organizationId: string;
  organizationName: string;
  canShare: boolean;
  capabilities: string[];
  shares: ComputerShare[];
}
export const sharingApi = {
  // Registration already authorizes the current global admin. Do not use the
  // auth store's registration flow, which would replace the sender's session.
  createUser: async (username: string, password: string): Promise<void> => {
    await apiClient.post('/auth/register', { username, password });
  },
  info: async (agentId: string): Promise<ComputerSharingInfo> =>
    (await apiClient.get<ComputerSharingInfo>('/agent-sharing', { params: { agentId } })).data,
  share: async (request: {
    agentId: string;
    username: string;
    capabilities: ShareCapability[];
    expiresAt: string | null;
  }): Promise<void> => {
    await apiClient.post('/agent-sharing', request);
  },
  revoke: async (id: string): Promise<void> => {
    await apiClient.post('/access-grants/revoke', undefined, { params: { id } });
  },
};
